module.exports = __webpack_public_path__ + "static/media/traffic-light.0240adeb.svg";